import { ISingleIdParams } from '../types/actionParams';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export class GetExtractDraftIdRequest extends Request<ISingleIdParams, IResult> {
  constructor(id: string) {
    super('getExtractDraftId', { id: id });
  }
}
